import React  from 'react'; 
import { Link } from "react-router-dom";
import Header from'../Component/Header';
const StudentCouncil = () => { 
  return (
     <>
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Students</li>
                 <li>Student Council</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Student Council</h1>
                    </div>
                </div>
                <div className="row studentcouncil">
                <div className="col-md-12">
                <h3>Senior Cabinet</h3>
              <table class="table" cellspacing="0" border="0">
              <tbody><tr>
              <th scope="col">S.No</th> <th scope="col">Designantion</th><th scope="col">Name</th>
              </tr>
              <tr><td>1</td><td>President (Boy)</td><td>Rudraansh Jaisawal</td></tr>
              <tr><td>2</td><td>President (Girl)</td><td>Shruti Kumari</td></tr>
              <tr><td>3</td><td>Vice President (Boy)</td><td>Salabh Singh</td></tr>
              <tr><td>4</td><td>Vice President (Girl)</td><td>Mihika Das</td></tr>
              <tr><td>5</td><td>Class 12 Councillor (Boy)</td><td>Prem Kumar Singh</td></tr>
              <tr><td>6</td><td>Class 12 Councillor (Girl)</td><td>Akanksha Priya</td></tr>
              <tr><td>7</td><td>Safety Coordinator (Boy)</td><td>Aman Khan</td></tr>
              <tr><td>8</td><td>Safety Coordinator (Girl)</td><td>Nidhi Singh</td></tr>
              <tr><td>9</td><td>Discipline Coordinator (Boy)</td><td>Arpit Tripathy</td></tr>
              <tr><td>10</td><td>Discipline Coordinator (Girl)</td><td>Prishaa Mary Teresa Pereira</td></tr>
          </tbody></table>
</div>
 <div className="col-md-6">
 <h3>Akbar House</h3>
<table class="table" cellspacing="0" border="0">
<tbody><tr>
<th scope="col">S.No</th><th scope="col">Designantion</th><th scope="col">Name</th>
</tr>  
<tr>
<td>1</td>
<td>Captain (Boy)</td>
<td>Aditya Kumar</td>
</tr>
<tr>
<td>2</td>
<td>Captain (Girl)</td>
<td>Shifa Fatema</td>
</tr>
<tr>
<td>3</td>
<td>Vice Captain (Boy)</td>
<td>Aarabh</td>
</tr>
<tr>
<td>4</td>
<td>Vice Captain (Girl)</td>
<td>Harshita Yadav</td>
</tr>
<tr>
<td>5</td>
<td>Coordinator</td>
<td>N Vedika</td>
</tr>
</tbody></table>
</div>
<div className="col-md-6">
 <h3>Ashoka House</h3>
<table class="table" cellspacing="0" border="0">
<tbody><tr>
<th scope="col">S.No</th><th scope="col">Designantion</th><th scope="col">Name</th>
</tr>
<tr>
<td>1</td>
<td>Captain (Boy)</td>
<td>Rohit Singh</td>
</tr>
<tr>
<td>2</td>
<td>Captain (Girl)</td>
<td>Ananya Sharma</td>
</tr>
<tr>
<td>3</td>
<td>Vice Captain (Boy)</td>
<td>Vanshaj Nilesh Rangooni</td>
</tr>
<tr>
<td>4</td>
<td>Vice Captain (Girl)</td>
<td>Aditi Kumari</td>
</tr>
<tr>
<td>5</td>
<td>Coordinator</td>
<td>Gunjan Srivastava</td>
</tr>
</tbody></table>
</div>
<div className="col-md-6">
 <h3>Nehru House</h3>
<table class="table" cellspacing="0" border="0">
<tbody><tr>
<th scope="col">S.No</th><th scope="col">Designantion</th><th scope="col">Name</th>
</tr> 
<tr>
        <td>1</td>
        <td>Captain (Boy)</td>
        <td>Alok Kumar Mishra</td>
      </tr>
      <tr>
        <td>2</td>
        <td>Captain (Girl)</td>
        <td>Anshita Singh</td>
      </tr>
      <tr>
        <td>3</td>
        <td>Vice Captain (Boy)</td>
        <td>Akshat</td>
      </tr>
      <tr>
        <td>4</td>
        <td>Vice Captain (Girl)</td>
        <td>Swasti Sinha</td>
      </tr>
      <tr>
        <td>5</td>
        <td>Coordinator</td>
        <td>B Swati</td>
      </tr>
</tbody></table>
</div>
<div className="col-md-6">
 <h3>Tagore House</h3>
<table class="table" cellspacing="0" border="0">
<tbody><tr>
<th scope="col">S.No</th><th scope="col">Designantion</th><th scope="col">Name</th>
</tr> 
<tr>
<td>1</td>
<td>Captain (Boy)</td>
<td>Abhinav Raj</td>
</tr>
<tr>
<td>2</td>
<td>Captain (Girl)</td>
<td>Arpita Mishra</td>
</tr>
<tr>
<td>3</td>
<td>Vice Captain (Boy)</td>
<td>Aditya Singh</td>
</tr>
<tr>
<td>4</td>
<td>Vice Captain (Girl)</td>
<td>Jasmit Kaur</td>
</tr>
<tr>
<td>5</td>
<td>Coordinator</td>
<td>Sparsh Sinha</td>
</tr>
</tbody></table>
</div>
                </div>
            </div>
        </div>
     </>
  )
}

export default StudentCouncil

